export function SemanticImageSearchIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M8.66699 4.77832H8.67305"
        stroke="#E099FF"
        strokeWidth="0.909162"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.49951 12.0008C5.08917 12.0008 3.66582 12.0008 3.66582 12.0008C3.22376 12.0008 2.7998 11.8252 2.48722 11.5126C2.17463 11.2 1.99902 10.776 1.99902 10.334V3.6668C1.99902 3.22473 2.17463 2.80078 2.48722 2.48819C2.7998 2.17561 3.22376 2 3.66582 2H10.333C10.7751 2 11.199 2.17561 11.5116 2.48819C11.8242 2.80078 11.9998 3.22473 11.9998 3.6668L11.9998 6.5"
        stroke="#E099FF"
        strokeWidth="0.909162"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 8L4.5 6.23625C4.964 5.92125 5.536 5.92125 6 6.23625L8 7.64725"
        stroke="#E099FF"
        strokeWidth="0.692164"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 9.5C7 10.163 7.26339 10.7989 7.73223 11.2678C8.20107 11.7366 8.83696 12 9.5 12C10.163 12 10.7989 11.7366 11.2678 11.2678C11.7366 10.7989 12 10.163 12 9.5C12 8.83696 11.7366 8.20107 11.2678 7.73223C10.7989 7.26339 10.163 7 9.5 7C8.83696 7 8.20107 7.26339 7.73223 7.73223C7.26339 8.20107 7 8.83696 7 9.5Z"
        stroke="#E099FF"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5 11.5L13 13"
        stroke="#E099FF"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
